<ng-container #rightDrawerContainer></ng-container>
<ng-template #offerDetailV2>
    <div class="offer-detail-v2-wrapper" [ngClass]="{'p-0': isBXGYEligibleOffer}">
        <offer-detail-al-v1
            [offer]="coupon"
            [product]= "product"
            [TriggerElement]="detailsDrawerTriggeredComponent"
            (backtoTriggeredComponent) = "loadTriggeredComponent($event)"
            [configObj]="configObj"
            [isBXGYEligibleOffer]="isBXGYEligibleOffer"
            >
        </offer-detail-al-v1>


        <div class="product-grid-container">
            <p *ngIf="!isBXGYEligibleOffer || !upcList.length || !eligibleUpcList.length" role="heading" aria-level="2" class="pl-4 pr-4 qualifying-products-text" data-qa="qlfy-prd-txt">Qualifying Product(s)</p>

        <offer-qualified-products-al-v1
            data-infinite-scroll-type="client" 
            data-driven="catalog"
            data-load-type="loadmore" 
            data-load-more-mobile-items="10"
            data-load-more-tablet-items="10" 
            data-load-more-desktop-items="10"
            data-api-type="c-products-by-upc-drawer"
            [dataValue] ="dataValue"
            [offer]="coupon"
            [isBXGYEligibleOffer]="isBXGYEligibleOffer"
            [configObj]="configObj">
        </offer-qualified-products-al-v1>

        </div>

    </div>

</ng-template>

   <ng-template #couponList>
        <coupon-list-al-v1 [couponListData]="couponListData" [configObj]="configObj"></coupon-list-al-v1>
    </ng-template>

<ng-template #bogoDetail>
    <div class="offer-detail-v2-wrapper">
            <offer-detail-al-v1
            [product]= "product"
            [TriggerElement]="detailsDrawerTriggeredComponent"
            (backtoTriggeredComponent) = "loadTriggeredComponent($event)"
            [configObj]="configObj"
            >
            </offer-detail-al-v1>

        <div class="product-grid-container">
            <p role="heading" aria-level="2" class="qualifying-products-text" data-qa="qlfy-prd-txt">Qualifying Product(s)</p>
            <offer-qualified-products-al-v1
                    data-infinite-scroll-type="client"
                    data-driven="static"
                    data-load-type="loadmore"
                    data-load-more-mobile-items="10"
                    data-load-more-tablet-items="10"
                    data-load-more-desktop-items="10"
                    data-api-type="s-bogo"
                    [dataValue] ="dataValue"
                    [configObj]="configObj"
                    [staticProducts] = "productList">
            </offer-qualified-products-al-v1>
        </div>
    </div> 
</ng-template>

<ng-template #ndcOfferDetail>
    <div class="offer-detail-v2-wrapper">
        <ndc-offer-detail-al-v1 [offer]="coupon" [TriggerElement]="detailsDrawerTriggeredComponent"></ndc-offer-detail-al-v1>

        <div class="product-grid-container">
            <p role="heading" aria-level="2" class="qualifying-products-text" data-qa="qlfy-prd-txt">Eligible Items</p>

            <offer-qualified-products-al-v1
                data-infinite-scroll-type="client" 
                data-driven="catalog"
                data-load-type="loadmore" 
                data-load-more-mobile-items="10"
                data-load-more-tablet-items="10" 
                data-load-more-desktop-items="10"
                data-api-type="c-products-by-upc-drawer"
                [dataValue] ="dataValue"
                [configObj]="configObj">
            </offer-qualified-products-al-v1>
        </div>
    </div>
</ng-template>

<ng-template #customizeDrawer>
    <customize-product-al-v1
            [product]= "product"
            [configObj]="configObj"
            [customizationDetails]="customizationDetails"
    ></customize-product-al-v1>
</ng-template>

<ng-template #prebookSlot>
    <quantity-stepper-al-v2 [product]="product" [hideCTA]="true" [calledBy]="'prebook-slot-drawer'"
        [configObj]="configObj" [qtyStepperOptions]="qtyStepperOptions">
    </quantity-stepper-al-v2>
</ng-template>

<div *ngIf="showSpinner" id="loadingConSmall" class="loading-div-small">
    <div class="loading-spinner">
        <div class="large progress" alt="Loading...">
            <div class="prog1">
                <div class="prog2"></div>
            </div>
        </div>
    </div>
</div>
